import { render, staticRenderFns } from "./ActionsButtons.vue?vue&type=template&id=2c6e13a5&"
import script from "./ActionsButtons.vue?vue&type=script&lang=js&"
export * from "./ActionsButtons.vue?vue&type=script&lang=js&"
import style0 from "./ActionsButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports